import React, { useMemo } from 'react';
import { Column } from '@ant-design/plots';
import CustomCard from '@components/CustomCard';
import useSwr from '@hooks/useSwr';
import { useTranslation } from 'react-i18next';

const DevicesByDepartment = () => {
  const { t } = useTranslation('dashboard');

  const { data } = useSwr(
    '/service-proxy/inventory/MOT/dashboards/count-by-child',
  );

  const sortedData = useMemo(
    () =>
      data
        ?.sort(
          (a: { total: number }, b: { total: number }) => a?.total - b?.total,
        )
        ?.reverse(),
    [data],
  );

  const config = useMemo(
    () => ({
      data: sortedData ?? [],
      xField: 'customerName',
      yField: 'total',
      columnWidthRatio: 0.6,
      color: '#1ca9e6',
      meta: {
        total: {
          alias: t('devices'),
        },
      },
    }),
    [sortedData, t],
  );

  return (
    <CustomCard
      title={t('devicesByDepartments')}
      style={{ width: '100%' }}
      bodyStyle={{ padding: 16 }}
    >
      <Column {...config} />
    </CustomCard>
  );
};

export default DevicesByDepartment;
